import { useMemo } from 'react'
import { PlainItemsSelector } from 'app/common/ui-next/plain-selector'
import { BuildingId } from 'app/common/types/id'

import {
  filterActions,
  useFilterOptionsLoadingByKey,
  useFilterOptions,
  useFilter,
} from '../../filterStore'

import { sortByTitle } from './helpers'

export const BuildingControl = () => {
  const id = useFilter('buildingId')
  const orgId = useFilter('orgId')
  const buildingsByOrgId = useFilterOptions('buildingsByOrgId')
  const loading = useFilterOptionsLoadingByKey('buildings')

  const selection = useMemo(() => (id.draft ? [id.draft] : []), [id.draft])
  const defaultSelection = useMemo(() => (id.default ? [id.default] : []), [id.default])

  const items = useMemo(
    () => (orgId.draft && buildingsByOrgId[orgId.draft]) ?? [],
    [orgId.draft, buildingsByOrgId],
  )

  return (
    <PlainItemsSelector
      id="building"
      label="Корпус ОУ"
      header="Выбор корпуса ОУ"
      pleaseSelectText="Все"
      items={items}
      selection={selection}
      defaultSelection={defaultSelection}
      onChange={([selected]) =>
        filterActions.selectDraftBuilding(selected as BuildingId | undefined)
      }
      loading={loading}
      sortFunc={sortByTitle}
      selectedAllOnEmptySelection={false}
      disabled={!orgId.draft}
      skipUpperSpace
      alwaysAutoSelect
    />
  )
}
